import styled from "styled-components";

export const BitsContStyled = styled.div`
  & .bits-list > div {
    background-color: white;
    border-radius: 12px;
    -webkit-backdrop-filter: blur(30px);
    backdrop-filter: blur(30px);
    padding: 8px 12px;
  }

  .bits-list {
    margin-top: 5px;
    overflow-y: auto;
    overflow-x: hidden;
    height: 95%;
    scrollbar-width: thin;
  }
`;
